export default __webpack_public_path__ + "static/media/b1f6caf2-3ead-43c3-87ff-bfe7733665f8.15814461.jpg";